import { render, staticRenderFns } from "./ProfileMenu.vue?vue&type=template&id=5d56256a"
import script from "./ProfileMenu.vue?vue&type=script&lang=ts"
export * from "./ProfileMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports